
import { useState } from 'react';
import Hero from './components/Hero';
import ParaQuemE from './components/ParaQuemE';
import Problema from './components/Problema';
import Aprendizado from './components/Aprendizado';
import Bonus from './components/Bonus';
import Habilidades from './components/Habilidades';
import Resultados from './components/Resultados';
import ParaPais from './components/ParaPais';
import Investimento from './components/Investimento';
import FAQ from './components/FAQ';
import ChamadaFinal from './components/ChamadaFinal';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="bg-dark-900 min-h-screen overflow-x-hidden">
      {/* Background Effects */}
      <div className="fixed inset-0 pointer-events-none">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-neon-blue/20 rounded-full blur-[120px] animate-pulse-slow"></div>
        <div className="absolute top-1/3 right-1/4 w-96 h-96 bg-neon-purple/20 rounded-full blur-[120px] animate-pulse-slow" style={{ animationDelay: '2s' }}></div>
        <div className="absolute bottom-1/4 left-1/3 w-96 h-96 bg-neon-pink/10 rounded-full blur-[120px] animate-pulse-slow" style={{ animationDelay: '4s' }}></div>
      </div>

      <div className="relative z-10">
        <Hero />
        <ParaQuemE />
        <Problema />
        <Aprendizado />
        <Bonus />
        <Habilidades />
        <Resultados />
        <ParaPais />
        <Investimento />
        <FAQ />
        <ChamadaFinal />
        <Footer />
      </div>
    </div>
  );
}
